import { render, staticRenderFns } from "./AlphaCalendarAvailability.vue?vue&type=template&id=24456eba&scoped=true"
import script from "./AlphaCalendarAvailability.vue?vue&type=script&lang=js"
export * from "./AlphaCalendarAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24456eba",
  null
  
)

export default component.exports